import { ApiGetRequest, ApiBlobGetRequest } from '../../../api';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Laporan Faktur Pajak',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Faktur',
        href: '/adm/fin/faktur-pajak/laporan-faktur',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'created_at',
    sortDesc: false,
    fields: [
      {
        key: 'trans_date',
        label: 'Tanggal',
      },
      {
        key: 'trans_faktur',
        label: 'Faktur Pajak',
      },
      {
        key: 'coretax_no',
        label: 'Coretax No',
      },
      {
        key: 'trans_code',
        label: 'Faktur OR',
      },
      {
        key: 'trans_principle',
        label: 'Nama Customer',
      },
      {
        key: 'trans_address',
        label: 'Address',
      },
      {
        key: 'trans_npwp',
        label: 'NPWP',
      },
      {
        key: 'trans_hpp',
        label: 'DPP',
      },
      {
        key: 'trans_ppn',
        label: 'PPN',
      },
      {
        key: 'trans_ppn',
        label: 'PPN',
      },
      {
        key: 'trans_nominal',
        label: 'TOTAL',
      },
    ],
    detail: false,
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeLapFaktur(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListLapFaktur({ commit, state }, payload = {}) {
    commit('changeLapFaktur', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      ...payload,
      start_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 0 &&
        payload.date_filter[0]
          ? moment(payload.date_filter[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        payload &&
        payload.date_filter &&
        payload.date_filter.length > 1 &&
        payload.date_filter[1]
          ? moment(payload.date_filter[1]).format('YYYY-MM-DD')
          : '',
    };

    if (payload && payload.export) {
      let result = await ApiBlobGetRequest(`fin/faktur/report`, params);
      commit('changeLapFaktur', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = new Blob([result.data], {
          type:
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        if (payload.type == 'laporan') {
          link.download = 'report_faktur.xlsx';
        } else {
          link.download = 'report_faktur.csv';
        }

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    } else {
      let result = await ApiGetRequest(`fin/faktur/report`, params);
      commit('changeLapFaktur', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? result.data.object : [];
    }
  },

  async getDetailLapFaktur({ commit, state }, payload = null) {
    commit('changeLapFaktur', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/faktur/${payload.id}`);
    commit('changeLapFaktur', {
      loading: false,
    });

    if (!result.error) {
      commit('changeLapFaktur', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });
    }

    return result.error ? false : true;
  },
};
